import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "primecase",
  UserStorage: "qgn9rC5VUEywg6+zRuTgVg==",
  UserToken: "TR+1byZUWEeZvjw0Boh66w==",
  UrlApi: "https://prd-ecommerce-pri-api.primecase.com.br/api",
  // UrlApi: "https://localhost:44388/api",  
  UrlLoja: "https://prd-ecommerce-pri-web.primecase.com.br",
  UrlServiceHost: "https://prd-pri-svc-api.primecase.com.br/",
  //  UrlServiceHost: "http://localhost:5001/",
  OrgId: "45ssiuz3",
  ProviderMerchantId: "braspag_marlim_advanced"
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#000",
      light: "#B799F2",
      //lighter: "#ece6f7",
      dark: darkenColor("#000", 10), // Escurece em 20%
    },
    secondary: {
      main: "#4dbf41",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
